import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-39828224")

_pushScopeId("data-v-39828224")
const _hoisted_1 = {
  class: "justify-center items-center sm:max-w-md mt-6 m-4 lg:w-3/5 sm:m-auto",
  style: {"font-family":"Nunito"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "-mr-6 md:-mr-2" }, null, -1)
const _hoisted_3 = { class: "z-0 text-3xl bold text-bp-dark p-5 pt-0 pb-0" }
const _hoisted_4 = { class: "px-6 text-sm text-gray-400" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FullScreenSpinner = _resolveComponent("FullScreenSpinner")
  const _component_input_nick_mail = _resolveComponent("input-nick-mail")
  const _component_DefaultButton = _resolveComponent("DefaultButton")
  const _component_DefaultCardLayout = _resolveComponent("DefaultCardLayout")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_FullScreenSpinner, {
      id: "sendResetPasswordSpinner",
      "show-spinner-alternative-text": false,
      "data-aos": "zoom-in-up",
      "loading-text": _ctx.$t("loading.ResendPasswordLink.loadingText"),
      "data-aos-anchor": "sendResetPasswordSpinner"
    }, null, 8, ["loading-text"]), [
      [_vShow, _ctx.isSending]
    ]),
    _hoisted_2,
    _createVNode(_component_DefaultCardLayout, { "card-padding": "px-6 pb-6 sm:px-9 py-6" }, {
      default: _withId(() => [
        _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("auth.ForgotPasswordComponent.forgotPasswordTitle")), 1),
        _createVNode("form", {
          class: "space-y-5 mt-5",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
        }, [
          _createVNode(_component_input_nick_mail, {
            email: _ctx.user.email,
            "onUpdate:email": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.email = $event))
          }, null, 8, ["email"]),
          _createVNode(_component_DefaultButton, {
            "button-text": _ctx.$t('auth.ForgotPasswordComponent.forgotBtnSend'),
            "button-type": "submit",
            "button-width": "w-full"
          }, null, 8, ["button-text"]),
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("auth.ForgotPasswordComponent.forgotPasswordDetail")), 1),
          _createVNode(_component_DefaultButton, {
            "button-text": _ctx.$t('auth.ForgotPasswordComponent.forgotBtnResend'),
            "button-type": "submit",
            "button-width": "w-full"
          }, null, 8, ["button-text"])
        ], 32)
      ]),
      _: 1
    })
  ]))
})